export default __webpack_public_path__ + "static/media/user.96156881.png";